<template>
  <div class="d-flex justify-center flex-column">
    <div v-if="getRestrictStatus" class="mt-n16">
      <Error403 />
    </div>
    <div v-else>
      <v-btn
        outlined
        width="70px"
        small
        class="d-flex px-0 my-1 ml-3 align-center success-text text-capitalize"
        v-if="isExtension && extensionList"
        @click="extensionList = false"
      >
        <v-icon size="14" class="success-text mr-1">
          mdi-keyboard-backspace
        </v-icon>
        <span class="caption">Back</span>
      </v-btn>
      <StartTask
        v-show="!isExtension"
        @stopAttempt="stop = false"
        :stopped="stop"
        class="mt-5"
        :class="
          (getActiveTask || getSelectedCompany.role == 'employee') &&
          getView == 'list'
            ? 'mb-2'
            : 'mb-2'
        "
      />
      <div
        :class="[
          { 'width-expand': getSidebarMini },
          { 'width-compress': !getSidebarMini },
          {
            'width-sm mx-4 flex-column-reverse align-end':
              $vuetify.breakpoint.xs,
          },
        ]"
        class="d-flex align-start"
      >
        <div
          v-if="
            getView == 'list' &&
              (getSelectedCompany.role == 'employee' ||
                (getActiveTask && getSelectedCompany.role != 'employee')) &&
              !isExtension &&
              getOnlineStatus &&
              !$vuetify.breakpoint.xs
          "
          @click="openAssignTaskDialog = true"
          class="mt-1 ml-7 pointer"
        >
          <v-icon color="#1CC283" size="20">
            mdi-checkbox-marked-outline
          </v-icon>
          <span class="dark-purple-text" style="font-size: 13px">
            <span>Wanna add a future task?</span>
            <a class="success-text font-weight-bold"> Click Here </a>
          </span>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex"></div>
      </div>
    </div>
    <!-- Task List View -->
    <MobileTaskList
      v-if="(!isExtension && $vuetify.breakpoint.xs) || extensionList"
      @stopTask="stop = true"
    />

    <TaskList
      v-else-if="(!isExtension || extensionList) && getView == 'list'"
      @stopTask="stop = true"
      :headers="_headers"
    />

    <!-- Kanban View -->
    <Kanban v-if="getView == 'kanban' && getSelectedCompany.subscribed_plan && getSelectedCompany.subscribed_plan.toLowerCase()!='basic'" @stopTask="stop = true" />
    <!-- Extension task list -->
    <ExtensionTaskPage v-if="isExtension && !extensionList" />
    <!-- View list button for extension -->
    <div
      v-if="!extensionList && isExtension"
      class="d-flex align-center success-text"
    >
      <span class="pointer ml-9 my-2" @click="extensionList = true"
        >View Task List</span
      >
      <v-icon class="success-text ml-2"> mdi-exit-to-app </v-icon>
    </div>
    <!-- Assign Task Dialog -->
    <AssignTaskModal :openAssignTaskDialog.sync="openAssignTaskDialog" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "TaskHead",
  components: {
    TaskList: () => import("@/components/Tasks/TaskList"),
    Kanban: () => import("@/components/Tasks/KanbanView/KanbanLayout"),
    ExtensionTaskPage: () => import("@/components/Tasks/ExtensionTaskPage"),
    StartTask: () => import("@/components/Tasks/StartTask"),
    AssignTaskModal: () => import("./AssignTaskModal"),
    Error403: () => import("@/components/Includes/403.vue"),
    MobileTaskList: () =>
      import("@/components/Tasks/MobileView/MobileTaskList.vue"),
  },
  data() {
    return {
      extensionList: false,
      dialog: false,
      stop: false,
      openAssignTaskDialog: false,
      list: null,
      employerHeaders: [
        {
          text: "",
          value: "data-table-expand",
          class: "table-header-bg pl-3 pr-0",
          cellClass: "px-2",
        },
        {
          text: "Ticket #",
          value: "sr_no",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1 ",
          width: "60px",
        },
        {
          value: "title",
          text: "Task",
          sortable: false,
          class: "table-header-bg px-1 dark-purple-text",
          cellClass: "px-1 py-1",
          width: "35%",
        },
        {
          value: "assigned_by",
          text: "Assigner",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "members",
          text: "Assignee",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "due_date",
          text: "Due",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "priority",
          text: "Priority",
          sortable: false,
          class: "table-header-bg px-1 dark-purple-text",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "created_at",
          text: "Assigned Date",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },

        {
          value: "status",
          text: "Status",
          sortable: false,
          class: "table-header-bg px-1 dark-purple-text",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "added_at",
          text: "Activity Date",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "members.duration",
          text: "Duration",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          width: "7%",
          align: "center",
        },
        {
          value: "actions",
          text: "Action",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
        },
      ],
      ownerHeaders: [
        {
          text: "",
          value: "data-table-expand",
          class: "table-header-bg pl-3 pr-0",
          cellClass: "px-2",
        },
        {
          text: "Ticket #",
          value: "sr_no",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1 ",
          width: "60px",
        },
        {
          value: "title",
          text: "Task",
          sortable: false,
          class: "table-header-bg px-1 dark-purple-text",
          cellClass: "px-1 py-1",
          width: "35%",
        },
        {
          value: "assigned_by",
          text: "Assigner",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "members",
          text: "Assignee",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "due_date",
          text: "Due",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "priority",
          text: "Priority",
          sortable: false,
          class: "table-header-bg px-1 dark-purple-text",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "created_at",
          text: "Assigned Date",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },

        {
          value: "status",
          text: "Status",
          sortable: false,
          class: "table-header-bg px-1 dark-purple-text",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "added_at",
          text: "Activity Date",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          align: "center",
        },
        {
          value: "members.duration",
          text: "Duration",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1",
          width: "7%",
          align: "center",
        },
        {
          value: "actions",
          text: "Action",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "pl-3 pr-1",
          align: "center",
        },
      ],
      extensionHeaders: [
        {
          text: "",
          value: "data-table-expand",
          class: "table-header-bg pl-3 pr-0",
          cellClass: "pl-2 pr-0",
        },
        {
          text: "Ticket #",
          value: "sr_no",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1 ",
        },
        {
          value: "title",
          text: "Task",
          sortable: false,
          class: "table-header-bg px-1",
          cellClass: "px-1 mr-2",
        },
        {
          value: "members.duration",
          text: "Duration",
          sortable: false,
          class: "table-header-bg pl-1 pr-0",
          cellClass: "px-5",
        },
        {
          value: "actions",
          text: "Action",
          sortable: false,
          class: "table-header-bg px-5",
          cellClass: "px-1",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getSidebarMini",
      "getSelectedCompany",
      "getShowAllTasks",
      "getTaskDateFilter",
      "setTaskFilter",
      "getRestrictStatus",
      "getView",
      "getActiveTask",
      "getTaskTitleFilter",
      "getTaskColumn",
      "getOnlineStatus",
      'getCustomDateRange'
    ]),
    _headers() {
      if (this.isExtension) return this.extensionHeaders;
      if (this.getSelectedCompany.role == "owner")
        return this.ownerHeaders.filter((item) => {
          return this.getTaskColumn(item.value);
        });
      else
        return this.employerHeaders.filter((item) => {
          return this.getTaskColumn(item.value);
        });
    },
    toggleView: {
      get() {
        return this.getView;
      },
      set(newName) {
        return newName;
      },
    },
  },
  mounted() {
    if (this.isExtension) {
      this.$store.commit("setView", "list");
    }
    if (this.getTaskDateFilter == "Today")
      this.$store.commit("setTaskFilter", {
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      });
    else if (this.getTaskDateFilter == "Yesterday")
      this.$store.commit("setTaskFilter", {
        start_date: moment()
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        end_date: moment()
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      });
    else if (this.getTaskDateFilter == "Last 7 days")
      this.$store.commit("setTaskFilter", {
        start_date: moment()
          .subtract(6, "day")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      });
    else if (this.getTaskDateFilter == "Last 30 days")
      this.$store.commit("setTaskFilter", {
        start_date: moment()
          .subtract(29, "day")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      });
    else if (this.getTaskDateFilter == "This month") {
      this.$store.commit("setTaskFilter", {
        start_date: moment()
          .clone()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date: moment()
          .clone()
          .endOf("month")
          .format("YYYY-MM-DD"),
      });
    } else if (this.getTaskDateFilter == "Last month") {
        return [
        moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 
        moment().subtract(1, 'months').endOf("month").format('YYYY-MM-DD'),
         ];
         }
        else if (this.getTaskDateFilter == "Custom range") {
          return [this.getCustomDateRange[0], 
                  this.getCustomDateRange[1]];
           } else if (this.getTaskDateFilter == "All time")
      this.$store.commit("setTaskFilter", {
        start_date: "2000-01-01",
        end_date: moment().format("YYYY-MM-DD"),
      });
  },

  watch: {
    dialog(val) {
      if (val) {
        document.addEventListener("mousedown", this.mousedownHandler);
      } else {
        document.removeEventListener("mousedown", this.mousedownHandler);
      }
    },
  },

  methods: {
    mousedownHandler(e) {
      if (e.target.classList.contains("v-overlay__scrim")) this.dialog = false;
    },
    addTaskModal() {
      this.dialog = true;
    },
    // For kanban

    toggleTasklistView(view) {
      this.$store.commit("setView", view);
    },
  },
};
</script>
<style scoped>
#add-task {
  background-color: #2758f6;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: sans-serif;
}
#task-table {
  padding: 10px;
}
.width-expand {
  width: calc(100vw - 88px);
}
.width-compress {
  width: calc(100vw - 300px);
}
.width-sm {
  width: 90vw;
}
.height-width-default {
  width: 180px;
}
.height-width-sm {
  width: calc(100vw - 116px);
}
</style>
